import React from "react";
import colors from "../theme/colors";

// Skeleton de chargement de la page détail réservation (blocs grisés).
// 100% <div> : aucune dépendance externe, aucun style interactif.
function ReservationSkeleton() {
  const cardStyle = {
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    width: 320,
    borderRadius: 7,
    marginRight: 20,
    marginBottom: 20,
    backgroundColor: colors.white,
    padding: 16,
  };

  const bar = (w, h = 12) => (
    <div
      style={{
        width: w,
        height: h,
        borderRadius: 6,
        backgroundColor: "#e6e8eb",
        marginBottom: 10,
      }}
    />
  );

  const card = (widths) => (
    <div style={cardStyle}>
      {bar("50%", 18)}
      {widths.map((w, i) => (
        <React.Fragment key={i}>{bar(w)}</React.Fragment>
      ))}
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
      <div
        style={{
          width: 320,
          height: 220,
          borderRadius: 10,
          backgroundColor: "#e6e8eb",
          marginRight: 20,
          marginBottom: 20,
        }}
      />
      {card(["80%", "60%", "70%"])}
      {card(["70%", "50%"])}
      {card(["60%", "80%", "50%"])}
    </div>
  );
}

export default ReservationSkeleton;
